<app-tab>
  <dx-data-grid
    id="trackersAssignmentsGridContainer"
    [dataSource]="ds"
    [showRowLines]="true"
    [remoteOperations]="false"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"
    [columnHidingEnabled]="true"
    [columnAutoWidth]="false"
    [errorRowEnabled]="false"
    [stateStoring]="{enabled: true, storageKey: 'app-trackers-assignments-grid'}"
    [libGridTitle]="{text: 'Transferts ' + tracker.imei}"
    [showBorders]="false">

    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="5%"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Date"
      dataField="date"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Action"
      dataField="action">
    </dxi-column>

    <dxi-column
      caption="Traceur"
      dataType="string"
      dataField="tracker_imei">
    </dxi-column>

    <dxi-column
      caption="Tracteur"
      dataField="vehicle_name">
    </dxi-column>

    <dxi-column
      caption="Utilisateur"
      dataField="user_email">
    </dxi-column>

    <dxi-column
      caption="Domain"
      dataField="domain_name">
    </dxi-column>

    <dxi-column
      caption="BU"
      dataField="business_unit_name">
    </dxi-column>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" [fileName]="'liste-transferts-traceurs-' + tracker.imei"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>
  </dx-data-grid>
</app-tab>
